module.exports = __webpack_public_path__ + "img/logo.8588f5fa.png";